import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import Grid from "@mui/material/Grid";
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { DataGrid } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import { editProductPriceEvent } from '../../../_events/products/edit_price.event';
import { findProductsPriceByClientEvent } from '../../../_events/products/findProducts.event';
import { message } from "antd";
import { MAIN_ROUTES, APP_ROUTES } from '../../../_config/routes';
import { useQuery } from '../../../_utils/url_query_hook';
import { ROLES } from "../../../_config/roles";
import RolWrapper from "../../hoc/roles_wrapper";

const ButtonRolAuthComponent = RolWrapper(Button, [ROLES.root, ROLES.admin]);

const Prices = () => {

    const [render, setRender] = useState('info');
    const [item, setItem] = useState(null);

    const columns = [
        { field: 'product.ref', headerName: 'Referencia', width: 300,
        valueGetter: (params) => params.row.product ? params.row.product.ref : '',
            renderCell: (params) => {  
                return <span>{params.row.product ? params.row.product.ref : ''}</span>;
            }
        },
        { field: 'description', headerName: 'descripción', width: 400,
        valueGetter: (params) => params.row.product ? params.row.product.description : '',
            renderCell: (params) => {  
                return <span>{params.row.product ? params.row.product.description : ''}</span>;
            }
        },
        { field: 'price_mt', headerName: 'Precio MT', width: 200 },
        { field: 'price_kg', headerName: 'Precio KG', width: 200 },
        { field: '', headerName: 'Acciones', width: 100, sortable: false, filterable: false,
            renderCell: (params) => {
                const onClick = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    setItem(params.row); setRender('form');
                };    
                return <ButtonRolAuthComponent onClick={onClick}>Editar</ButtonRolAuthComponent>;
            }
        },
    ];

    let query = useQuery();

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <div style={{display: 'flex', flexDirection: 'row', width:'100%'}}>
                    <div style={{display: 'flex', flexDirection: 'row', width:'60%'}}>
                    <Typography variant="h6" component="h6">
                        Productos - Configuración de precios
                    </Typography>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width:'40%'}}>
                        {
                            render === 'info' ? 
                            <Link to={`${MAIN_ROUTES.app_modules}${APP_ROUTES.clients}`}>
                                <Button variant="contained">Volver a clientes</Button>
                            </Link>
                            :
                            <Button onClick={() => setRender('info')} variant="contained">Ver listado</Button>
                        }
                    </div>
                </div>
                <hr />
                {
                    render === 'info' ? <PriceInfo columns={columns} clientId={query.get("c")} /> : <ProductForm item={item} />
                }                
            </Grid>
        </Grid>
    );
}

const PriceInfo = (props) => {

    const [products, setProducts] = useState([]);

    const findProducts = () => {
        findProductsPriceByClientEvent(props.clientId)
        .then(data => {
            setProducts(data.list);
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    useEffect(() => {
        findProducts();
    }, []);

    return(
        <div style={{height:450, width: '100%' }}>
            <DataGrid
                rows={products}
                columns={props.columns}
                pageSize={8}
                rowsPerPageOptions={[8]}
                checkboxSelection={false}
                getRowId={(p) => p.uuid}
            />
        </div>
    );
}

const ProductForm = (props) => {
    let { item } = props; 

    const editProduct = (id) => {
        editProductPriceEvent(id)
        .then(data => {
            message.success('Precio actualizado');
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    return(
        <div style={{width: '100%'}}>
            <Grid container spacing={1}>
                <Grid item xs={12} md={12}>
                    <TextField 
                        disabled
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="product_ref" 
                        label="Referencia" 
                        variant="outlined"
                        size="small"
                        defaultValue={item ? item.product ? item.product.ref : null : null}
                    />        
                </Grid>
                <Grid item xs={12} md={12}>
                    <TextField 
                        disabled
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="product_description" 
                        label="Descripción" 
                        variant="outlined"
                        size="small"
                        defaultValue={item ? item.product ? item.product.description : null : null}
                    />        
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField 
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="product_price_price_mt" 
                        label="Precio por Metro" 
                        variant="outlined"
                        size="small"
                        type="number"
                        defaultValue={item ? item.price_mt : 0}
                    />        
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField 
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="product_price_price_kg" 
                        label="Precio por Kilo" 
                        variant="outlined"
                        size="small"
                        type="number"
                        defaultValue={item ? item.price_kg : 0}
                    />        
                </Grid>
                <Grid item xs={12} md={12}>
                    {
                        item ? <Button style={{width: '100%'}} onClick={() => editProduct(item.uuid)} variant="contained">Editar</Button>
                        : <></>
                    }      
                </Grid>                
            </Grid>
        </div>
    );
}

export default Prices;